/** The notice a write gets when someone else saved the asset first (409): what happened and **Reload**. */

import { RotateCw, TriangleAlert } from 'lucide-react';

export function StaleNotice({ onReload, reloading = false }: { onReload: () => void; reloading?: boolean }) {
  return (
    <div className="alert alert-warning form-alert stale-notice" role="alert">
      <TriangleAlert aria-hidden="true" />
      <div className="a-body">
        <b>Someone else changed this asset since you opened it.</b> Reload to get the latest version, then make your change
        again. Text you have not saved stays in its editor.
      </div>
      <button type="button" className="btn btn-secondary btn-sm" disabled={reloading} onClick={onReload}>
        <RotateCw aria-hidden="true" className={reloading ? 'spin' : undefined} /> Reload
      </button>
    </div>
  );
}
